import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Container, FormControl, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { useState } from 'react';
import { AppShell } from '../../components/AppShell/AppShell';
import { Footer } from '../../components/Footer/Footer';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { VideoCard } from '../../components/VideoCard/VideoCard';
import { Title } from '../../components/Title/Title';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useCurrentLanguage } from '../../../hooks/useCurrentLanguage';
import { ReactComponent as VideoSearchIcon } from '../../../assets/svg/video-search.svg';
import styles from './CategorieDetail.module.scss';

const CategorieDetail = () => {
  const { seriesTags } = useFirebase();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { t } = useTranslation();
  const { currentLanguage } = useCurrentLanguage();
  const [search, setSearch] = useState('');
  const category = seriesTags.find(({ tag }) => tag.id === id);

  if (!category) return <FullscreenLoader />;

  const normalizedSearch = search.trim().toLocaleLowerCase(currentLanguage);
  const videos = category.tagVideos.filter((video) => {
    if (!normalizedSearch) return true;
    return [
      video.title,
      video.description,
      video.author?.name,
      ...(video.tags || []).map((tag) => tag.label),
    ]
      .join(' ')
      .toLocaleLowerCase(currentLanguage)
      .includes(normalizedSearch);
  });

  return (
    <AppShell>
      <div className="d-flex flex-column flex-grow-1">
        <Title>{category.tag.label}</Title>
        <div className={`${styles.categoryHeader} d-flex mb-3 align-items-center justify-content-between`}>
          <div className="d-flex align-items-center">
            <Button
              aria-label={t('labels.tornaIndietro')}
              onClick={() => history.goBack()}
              className="tootor-button tootor-button--basic mr-3"
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </Button>
            <h1 className="text-page-title mb-0">{category.tag.label}</h1>
          </div>
          <InputGroup className={styles.categorySearch}>
            <InputGroup.Prepend>
              <InputGroup.Text className={styles.categorySearchIcon}>
                <VideoSearchIcon />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              aria-label={t('labels.cerca')}
              className={styles.categorySearchInput}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={t('labels.cerca')}
              size="lg"
              value={search}
            />
          </InputGroup>
        </div>
        <Container className="flex-grow-1">
          <div className={styles.videoGrid}>
            {videos.map((video, index) => (
              <VideoCard className="m-1" key={video.id} index={index} video={video} />
            ))}
          </div>
        </Container>
        <Footer />
      </div>
    </AppShell>
  );
};

export default CategorieDetail;
